<template>
  <div>
    <v-text-field
      @click="handleClick"
      class="d-none d-md-flex"
      label="Pesquisar"
      placeholder="Pesquisar"
      prepend-inner-icon="mdi-magnify"
      single-line
      hide-details
      solo
      dense
      flat
      readonly
    ></v-text-field>
    <v-btn @click="handleClick" class="d-flex d-md-none" icon>
      <v-icon>mdi-magnify</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  mixins: [],

  components: {},

  props: {},

  data() {
    return {};
  },

  methods: {
    handleClick() {
      this.$emit("click");
    },
  },

  computed: {},
};
</script>
